import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type LocationStoreState
 */
const initialState = {
  dashboardkpis: { loading: false, data: null, error: null },
  salesRepresentativeList: { loading: false, data: null, error: null },
  leadskpis: { loading: false, data: null, error: null },
  clientDashboardList: { loading: false, data: null, error: null },
  leadsPipeline: { loading: false, data: null, error: null },
  proposalPipeline: { loading: false, data: null, error: null },
  topDealsWonList: { loading: false, data: null, error: null },
  recentClosedDeals: { loading: false, data: null, error: null },
  winRate: { loading: false, data: null, error: null },
  winLoss: { loading: false, data: null, error: null },
  totalAgreements: { loading: false, data: null, error: null },
  clientSeatsKpis: { loading: false, data: null, error: null },
};

export const DashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchdashboardRequest: (state, action) => {
      state.dashboardkpis.loading = true;
      state.dashboardkpis.error = null;
    },
    fetchdashboardSuccess: (state, action) => {
      state.dashboardkpis.data = action.payload;
      state.dashboardkpis.loading = false;
      state.dashboardkpis.error = null;
    },
    fetchdashboardFailure: (state, action) => {
      state.dashboardkpis.data = null;
      state.dashboardkpis.loading = false;
      state.dashboardkpis.error = action.payload;
    },

    fetchsalesRepresentativeDashboardListRequest: (state, action) => {
      state.salesRepresentativeList.loading = true;
      state.salesRepresentativeList.error = null;
    },
    fetchsalesRepresentativeDashboardListSuccess: (state, action) => {
      state.salesRepresentativeList.data = action.payload;
      state.salesRepresentativeList.loading = false;
      state.salesRepresentativeList.error = null;
    },
    fetchsalesRepresentativeDashboardListFailure: (state, action) => {
      state.salesRepresentativeList.data = null;
      state.salesRepresentativeList.loading = false;
      state.salesRepresentativeList.error = action.payload;
    },

    fetchLeadsKPISDashboardRequest: (state, action) => {
      state.leadskpis.loading = true;
      state.leadskpis.error = null;
    },
    fetchLeadsKPISDashboardSuccess: (state, action) => {
      state.leadskpis.data = action.payload;
      state.leadskpis.loading = false;
      state.leadskpis.error = null;
    },
    fetchLeadsKPISDashboardFaliure: (state, action) => {
      state.leadskpis.data = null;
      state.leadskpis.loading = false;
      state.leadskpis.error = action.payload;
    },

    fetchClientDashboardListRequest: (state, action) => {
      state.clientDashboardList.loading = true;
      state.clientDashboardList.error = null;
    },
    fetchClientDashboardListSuccess: (state, action) => {
      state.clientDashboardList.data = action.payload;
      state.clientDashboardList.loading = false;
      state.clientDashboardList.error = null;
    },
    fetchClientDashboardListFailure: (state, action) => {
      state.clientDashboardList.data = null;
      state.clientDashboardList.loading = false;
      state.clientDashboardList.error = action.payload;
    },

    fetchRecentClosedDealsRequest: (state, action) => {
      state.recentClosedDeals.loading = true;
      state.recentClosedDeals.error = null;
    },
    fetchRecentClosedDealsSuccess: (state, action) => {
      state.recentClosedDeals.data = action.payload;
      state.recentClosedDeals.loading = false;
      state.recentClosedDeals.error = null;
    },
    fetchRecentClosedDealsFaliure: (state, action) => {
      state.recentClosedDeals.data = null;
      state.recentClosedDeals.loading = false;
      state.recentClosedDeals.error = action.payload;
    },

    fetchleadsPipelineRequest: (state, action) => {
      state.leadsPipeline.loading = true;
      state.leadsPipeline.error = null;
    },
    fetchleadsPipelineSuccess: (state, action) => {
      state.leadsPipeline.data = action.payload;
      state.leadsPipeline.loading = false;
      state.leadsPipeline.error = null;
    },
    fetchleadsPipelineFailure: (state, action) => {
      state.leadsPipeline.data = null;
      state.leadsPipeline.loading = false;
      state.leadsPipeline.error = action.payload;
    },

    fetchsmartproposalPipelineRequest: (state, action) => {
      state.proposalPipeline.loading = true;
      state.proposalPipeline.error = null;
    },
    fetchsmartproposalPipelineSuccess: (state, action) => {
      state.proposalPipeline.data = action.payload;
      state.proposalPipeline.loading = false;
      state.proposalPipeline.error = null;
    },
    fetchsmartproposalPipelineFailure: (state, action) => {
      state.proposalPipeline.data = null;
      state.proposalPipeline.loading = false;
      state.proposalPipeline.error = action.payload;
    },

    fetchTopDealsWonRequest: (state, action) => {
      state.topDealsWonList.loading = true;
      state.topDealsWonList.error = null;
    },
    fetchTopDealsWonSuccess: (state, action) => {
      state.topDealsWonList.data = action.payload;
      state.topDealsWonList.loading = false;
      state.topDealsWonList.error = null;
    },
    fetchTopDealsWonFaliure: (state, action) => {
      state.topDealsWonList.data = null;
      state.topDealsWonList.loading = false;
      state.topDealsWonList.error = action.payload;
    },

    fetchWinRateRequest: (state, action) => {
      state.winRate.loading = true;
      state.winRate.error = null;
    },
    fetchWinRateSuccess: (state, action) => {
      state.winRate.data = action.payload;
      state.winRate.loading = false;
      state.winRate.error = null;
    },
    fetchWinRateFaliure: (state, action) => {
      state.winRate.data = null;
      state.winRate.loading = false;
      state.winRate.error = action.payload;
    },

    fetchWinLossRequest: (state, action) => {
      state.winLoss.loading = true;
      state.winLoss.error = null;
    },
    fetchWinLossSuccess: (state, action) => {
      state.winLoss.data = action.payload;
      state.winLoss.loading = false;
      state.winLoss.error = null;
    },
    fetchWinLossFaliure: (state, action) => {
      state.winLoss.data = null;
      state.winLoss.loading = false;
      state.winLoss.error = action.payload;
    },

    fetchtotalAgreementsRequest: (state, action) => {
      state.totalAgreements.loading = true;
      state.totalAgreements.error = null;
    },
    fetchtotalAgreementsSuccess: (state, action) => {
      state.totalAgreements.data = action.payload;
      state.totalAgreements.loading = false;
      state.totalAgreements.error = null;
    },
    fetchtotalAgreementsFailure: (state, action) => {
      state.totalAgreements.data = null;
      state.totalAgreements.loading = false;
      state.totalAgreements.error = action.payload;
    },

    fetchClientSeatsKpisRequest: (state, action) => {
      state.clientSeatsKpis.loading = true;
      state.clientSeatsKpis.error = null;
    },
    fetchClientSeatsKpisSuccess: (state, action) => {
      state.clientSeatsKpis.data = action.payload;
      state.clientSeatsKpis.loading = false;
      state.clientSeatsKpis.error = null;
    },
    fetchClientSeatsKpisFailure: (state, action) => {
      state.clientSeatsKpis.data = null;
      state.clientSeatsKpis.loading = false;
      state.clientSeatsKpis.error = action.payload;
    },
  },
});

export const {
  fetchdashboardRequest,
  fetchdashboardSuccess,
  fetchdashboardFailure,

  fetchWorkstationDashboardListRequest,
  fetchWorkstationDashboardListSuccess,
  fetchWorkstationDashboardListFailure,

  fetchsalesRepresentativeDashboardListRequest,
  fetchsalesRepresentativeDashboardListSuccess,
  fetchsalesRepresentativeDashboardListFailure,

  fetchSmartSuiteDashboardAgreementListRequest,
  fetchSmartSuiteDashboardAgreementListSuccess,
  fetchSmartSuiteDashboardAgreementListFaliure,

  fetchLeadsKPISDashboardRequest,
  fetchLeadsKPISDashboardSuccess,
  fetchLeadsKPISDashboardFaliure,

  fetchClientDashboardListRequest,
  fetchClientDashboardListSuccess,
  fetchClientDashboardListFailure,

  fetchleadsPipelineRequest,
  fetchleadsPipelineSuccess,
  fetchleadsPipelineFailure,

  fetchsmartproposalPipelineRequest,
  fetchsmartproposalPipelineSuccess,
  fetchsmartproposalPipelineFailure,

  fetchTopDealsWonRequest,
  fetchTopDealsWonSuccess,
  fetchTopDealsWonFaliure,

  fetchRecentClosedDealsRequest,
  fetchRecentClosedDealsSuccess,
  fetchRecentClosedDealsFaliure,

  fetchWinRateRequest,
  fetchWinRateSuccess,
  fetchWinRateFaliure,

  fetchWinLossRequest,
  fetchWinLossSuccess,
  fetchWinLossFaliure,

  fetchtotalAgreementsRequest,
  fetchtotalAgreementsSuccess,
  fetchtotalAgreementsFailure,

  fetchClientSeatsKpisRequest,
  fetchClientSeatsKpisSuccess,
  fetchClientSeatsKpisFailure,
} = DashboardSlice.actions;

export const getDashboardState = (store) => store.dashboard?.dashboardkpis;
export const getSalesRepresentativeDashboardListState = (state) =>
  state.dashboard?.salesRepresentativeList;

export const getLeadsKPIS = (state) => state.dashboard?.leadskpis;

export const getClientDashboardListState = (store) =>
  store.dashboard?.clientDashboardList;

export const getleadsPipelineState = (store) => store.dashboard?.leadsPipeline;

export const getsmartproposalPipelineState = (store) =>
  store.dashboard?.proposalPipeline;

export const getTopDealWonList = (store) => store.dashboard.topDealsWonList;

export const getRecentClosedDeals = (store) =>
  store.dashboard.recentClosedDeals;

export const getWinRateData = (store) => store.dashboard.winRate;

export const getWinLossData = (store) => store.dashboard.winLoss;
export const gettotalAgreementData = (store) => store.dashboard.totalAgreements;

export const getClientSeatsKpisState = (store) =>
  store.dashboard?.clientSeatsKpis;

export default DashboardSlice.reducer;
